export const CSS_VAR_KEY_REGEX = /--\w+/;
export const CSS_VAR_REGEX = new RegExp('var\\s*\\(\\s*(--[^\\)]*)\\s*\\)', 'i');
export const PRECOLOR_REGEX_STRICT = new RegExp('^(\\d{1,3}),\\s*(\\d{1,3}),\\s*(\\d{1,3})$');
export const ACCECTABLE_CONRAST_RATIO = 4.5;
